import { gql } from "@apollo/client";

export const CREATE_LENS_MUTATION = gql`
  mutation CreateLens($input: CreateLensInput!) {
    createLens(input: $input) {
      id
      key
      name
      status
      content
      standards
      isPrimary
    }
  }
`;

export const SAVE_LENS_VERSION_MUTATION = gql`
  mutation SaveLensVersion($id: ID!, $content: String, $standards: JSON) {
    saveLensVersion(id: $id, content: $content, standards: $standards) {
      id
      key
      name
      status
      content
      standards
      isPrimary
      createdAt
    }
  }
`;

export const ACTIVATE_LENS_VERSION_MUTATION = gql`
  mutation ActivateLensVersion($id: ID!) {
    activateLensVersion(id: $id) {
      id
      key
      name
      status
      content
      standards
      isPrimary
      createdAt
    }
  }
`;
